// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hZxC","colBig":"styles_colBig__2K1uj","colSmall":"styles_colSmall__2R-QC"};